import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom"
import FormContainer from './FormContainer';
import EyeIcon from '../../components/icons/EyeIcon';
import EyeSlashFillIcon from '../../components/icons/EyeSlashFillIcon';
import { ForgotPasswordAPI, ForgotPasswordValidLinkAPI, NewPasswordAPI } from '../../API/auth';
import Swal from "sweetalert2";
import Loader from '../../views/admin/Common/Loader';
import CryptoJS from 'crypto-js';
import { useSnackbar } from 'notistack';

const SECRET_KEY = process.env.REACT_APP_HASH_SECRET_KEY;;
; // Change this to a secure key
function NewPassword() {
	const { id, token } = useParams();
	const navigate = useNavigate();
	const [PasswordCriteria, setPasswordCriteria] = useState({});
	const [CriteriaShow, setCriteriaShow] = useState(false);
	const [error, setError] = useState('');
	const [showPassword, setShowPassword] = useState({ password: true, confirm_password: true });
	const [value, setPassword] = useState({
		newPassword: '',
		confirmPassword: '',
		id: id,
		token: token
	})
	const [loaderStatus, setloaderStatus] = useState(true);
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		let callAPI = async () => {

			let isValid = await ForgotPasswordValidLinkAPI(id, token);

			if (isValid.data.status == false) {
				setloaderStatus(false);
				Swal.fire({
					title: "Invalid Link",
					text: "This link is invalid either you have already used it or it is expired",
					icon: "error",
					confirmButtonColor: "#3085d6",
					confirmButtonText: "OK",
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true,
                cancelButtonColor: "#d33",
				cancelButtonText: "Close"


				}).then((result) => {
					 if (result.isConfirmed) {
						// window.location.href('/logout')
						navigate('/dashboard')
					  } else if (result.isDismissed) {
						navigate('/dashboard')
			
					  }
				});
			} else {
				setloaderStatus(false);
			}
			console.log(isValid.data)
		}
		callAPI();
	}, [])
	const togglePasswordVisibility = () => {
		setShowPassword(prevState => ({
			...prevState,
			password: !prevState.password
		}));
	};

	const toggleConfirmPasswordVisibility = () => {
		setShowPassword(prevState => ({
			...prevState,
			confirm_password: !prevState.confirm_password
		}));
	};
	// const HandelChange = (event) => {
	// 	const { name, value } = event.target;
	// 	setPassword(prevState => ({
	// 		...prevState,
	// 		[name]: value
	// 	}));
	// }
	const HandelChange = (event) => {
		const { name, value } = event.target;
		setPassword(prevState => ({
			...prevState,
			[name]: value
		}));
		setError(''); // Reset the error on input change
	}
	// use for new password
	const PasswordValidation = (e) => {
		const { value } = e.target;
		const tempCriteria = {};
		tempCriteria.length = value.length >= 8;
		tempCriteria.uppercase = /[A-Z]/.test(value);
		tempCriteria.digit = /\d/.test(value);
		tempCriteria.special_character = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value);
		setPasswordCriteria(tempCriteria);
	}

	const HandelSubmit = async (event) => {
		event.preventDefault();
		if (value.newPassword === value.confirmPassword) {
			setError('');
			const encryptedPassword = CryptoJS.AES.encrypt(value.newPassword, SECRET_KEY).toString();
			const payload = {
				newPassword: encryptedPassword,
				id,
				token,
			};
			let res = await NewPasswordAPI(payload);
			if (res.data.status) {
				Swal.fire({
					title: "Password changed successfully",
					text: "Your password has been reset successfully.",
					icon: "success",
					confirmButtonColor: "#3085d6",
					confirmButtonText: "OK",
					allowOutsideClick: false,
					allowEscapeKey: false,
					  showCancelButton: true,
					  cancelButtonColor: "#d33",
					  cancelButtonText: "Close"

				}).then(result => {
					if (result.isConfirmed) {
						// window.location.href('/logout')
						navigate('/login')
					}
				})
			} else if (res.data.samePassword) {
				Swal.fire({
					title: "Invalid password",
					text: "New password can not be same as old password.",
					icon: "error",
					confirmButtonColor: "#3085d6",
					confirmButtonText: "OK",
					showCancelButton: true,
                	cancelButtonColor: "#d33",
					cancelButtonText: "Close"

				})
			}
			else {
				Swal.fire({
					title: "Something went wrong",
					text: "Unable to change password , please try again later.",
					icon: "error",
					confirmButtonColor: "#3085d6",
					confirmButtonText: "OK",
				})
			}
		} else {
			Swal.fire({
				title: "Password does not match",
				text: "You have provided the wrong password",
				icon: "error",
				confirmButtonColor: "#3085d6",
				confirmButtonText: "OK",
				showCancelButton: true,
                cancelButtonColor: "#d33",
				cancelButtonText: "Close"

			})
			// setError('Password does not match');
		}
	}
	return (
		<>
			{loaderStatus ? 
				<Loader />
				: null}
			<FormContainer>
				<form className='mt-3 login-form' onSubmit={HandelSubmit}>
					<label className='form-title mb-2'> RESET PASSWORD </label>
					<p className='form-heading mb-3' style={{ marginTop: "-6px" }}> Please enter your new password. </p>

					<div className="mb-4">
						<label className='mb-2 input-label' htmlFor="password" value={token}>New Password</label>
						<div className="position-relative">
							<input
								type={showPassword.password ? "password" : "text"}
								placeholder='New Password'
								// onChange={HandelChange}
								name='newPassword'
								value={value.password}
								className='form-control bg-transparent form-input'
								onChange={(e) => { HandelChange(e); PasswordValidation(e); }}
								onFocus={() => { setCriteriaShow(true) }}
								onBlur={() => { setCriteriaShow(false) }}
								required
							/>
							<i className="btn border-0 position-absolute end-0 top-0" type="button" onClick={togglePasswordVisibility}>

								{
									showPassword.password ? <EyeIcon /> : <EyeSlashFillIcon />
								}
							</i>
						</div>
						<div>
							{
								!CriteriaShow && !value.newPassword.trim() ?
									error.newPassword && <span className='text-danger'>{error.newPassword}</span>
									:

									<span className={PasswordCriteria.length && PasswordCriteria.uppercase && PasswordCriteria.digit && PasswordCriteria.special_character ? 'text-success' : 'text-danger'}>

										<span className={PasswordCriteria.length !== undefined && PasswordCriteria.length ? 'text-success' : 'text-danger'} data-length={PasswordCriteria.length}>Password must be at least 8 characters long</span> <br />

										<span className={PasswordCriteria.uppercase !== undefined && PasswordCriteria.uppercase ? 'text-success' : 'text-danger'} data-length={PasswordCriteria.uppercase}>Contain at least one uppercase letter</span><br />

										<span className={PasswordCriteria.digit !== undefined && PasswordCriteria.digit ? 'text-success' : 'text-danger'} data-length={PasswordCriteria.digit}>One digit</span>, and

										<span className={PasswordCriteria.special_character !== undefined && PasswordCriteria.special_character ? 'text-success' : 'text-danger'} data-length={PasswordCriteria.special_character}> one special character</span>.
										<br /></span>
							}
						</div>
					</div>
					<div className="mb-3">
						<label className='mb-2 input-label' htmlFor="password">Confirm Password</label>
						<div className="position-relative">
							<input
								type={showPassword.confirm_password ? "password" : "text"}
								placeholder='Confirm Password '
								name='confirmPassword'
								value={value.confirmPassword}
								onChange={HandelChange}
								required
								className='form-control bg-transparent form-input'
							/>
							<i className="btn border-0 position-absolute end-0 top-0" onClick={toggleConfirmPasswordVisibility}>
								{
									showPassword.confirm_password ? <EyeIcon /> : <EyeSlashFillIcon />
								}
							</i>
						</div>
					</div>
					{error && <span className='text-danger'>{error}</span>}
					<div className='pt-1 mb-4'>
						<button className='btn btn-light w-100 border-0 px-3 py-3 fs-5 fw-bold rounded-3 submit-button text-white' type='submit' > Reset Password </button>
					</div>
				</form>
			</FormContainer>
		</>
	)
}
export default NewPassword
